import * as React               from "react";
import {css, cx}                from "emotion";
import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {GuestModal}             from "@Xpresso/routes/common/guest-modal/guest-modal";
import {modifyWhiteElement}     from "@Xpresso/routes/brand/branded-login/branded-login";

export const BrandedCreateAccount = () => cs(
    consumeContext("themeScheme"),
    ["createModal", ({}, next) => GuestModal({
        content: "newAccount",
        next
    })],
    ["invert", ({themeScheme}, next) => next(modifyWhiteElement(themeScheme?.xpresso?.menuBackgroundColor))],
    ({themeScheme, createModal, invert}) => {
        const linkLabelCreate = `Create Account`
        return (
            <a className={cx("text-guest-create", {invert: invert},
                    css`color: ${themeScheme?.xpresso?.menuBackgroundColor} !important;`
                )}
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    createModal.show()
                }}
                xd-qa-type="link"
                xd-qa-name={linkLabelCreate}
            >
                {linkLabelCreate}
            </a>
        )
    }
);

